import {
  Box,
  Container,
  createTheme,
  FormControl,
  Grid,
  Link,
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ThemeProvider,
  Tooltip,
} from "@mui/material";
import Title from "../../components/Pages/Title";
// import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
// import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import StatusCard from "../../components/Pages/StatusCard";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useEffect, useState } from "react";
import * as Api from "../../openApi";
import { Block } from "../../openApi/api";
import Pagination from "../../components/Pagination";
// import { useUpcxChain } from "../../hook/useUpcxChain";
// import { GetInfoResult } from "upcx-js/dist/upcxjs-rpc-interfaces";
import { CalculatePassTime } from "../../utils";
import { useRecoilState } from "recoil";
import { ThemeLight } from "../../state/ThemeLight";
import { useUpcxChain } from "../../hook/useUpcxChain";
import { BlocksService } from "../../backend";

const AllBlock = () => {
  const { selectedShard } = useUpcxChain();

  const [blocks, setBlocks] = useState<Block[]>([]);

  const [limit, setLimit] = useState(25);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(0);

  const handleChange = (event: SelectChangeEvent) => {
    setLimit(parseInt(event.target.value));
    setPage(0);
  };

  const getBlocks = async () => {
    const result = await BlocksService.getBlocks(limit, page);
    setBlocks(result.blocks ?? []);
    setTotal(result.total ?? 0);
  };

  useEffect(() => {
    if (!selectedShard) {
      return;
    }

    setBlocks([]);
    getBlocks();
    // eslint-disable-next-line
  }, [limit, page, selectedShard]);

  return (
    <>
      <Title title="Blocks" smallTitle="" />

      <Container className="container-xxl pt-5 pb-12">
        <Grid container spacing={2} className="g-4 mb-4">
          <StatusCard
            title="Network Utilization (24H)"
            value="50.4%"
            sufix=""
            sufixCls=""
          />
          <StatusCard
            title="Last Safe Block"
            value={total.toString()}
            sufix=""
            sufixCls=""
          />
          <StatusCard
            title="PRODUCED BY MEV BUILDERS (24H)"
            value="100%"
            sufix=""
            sufixCls=""
          />
          <StatusCard
            title="Burnt Fees 🔥"
            value="0.00 UPC"
            sufix=""
            sufixCls=""
          />
        </Grid>

        <Box className="card">
          <Box className="card-body">
            <Box className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <Box>
                <span className="text-dark gap-1">
                  Total of {total.toLocaleString()} blocks
                </span>
                <Box className="d-block text-muted small">
                  (Showing blocks between #
                  {Math.max(total - (page + 1) * limit, 1)} to #
                  {total - page * limit})
                </Box>
              </Box>
              <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Pagination
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  total={total}
                />
              </Box>
            </Box>
          </Box>

          <TableContainer component={Paper} className="box-shadow-0">
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="left" width={1}>
                    Block
                  </TableCell>
                  <TableCell align="left">
                    <Tooltip title="Click show Datetime Format" placement="top">
                      <Link>Age</Link>
                    </Tooltip>
                  </TableCell>
                  <TableCell align="left">Txn</TableCell>
                  <TableCell align="left">Fee Recipient</TableCell>
                  <TableCell align="left">Total Fee</TableCell>
                  <TableCell align="left">Reward</TableCell>
                  <TableCell align="left">Burnt Fees (UPC)</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {blocks.map((data) => (
                  <TableRow>
                    <TableCell>
                      <Box className="hash-tag text-truncate">
                        <Link
                          href={`/block/${data.id}`}
                          className="myFnExpandBox_searchVal"
                        >
                          {data.id}
                        </Link>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Tooltip title={"7 secs ago"} placement="top">
                        <Box rel="tooltip">
                          {CalculatePassTime(
                            new Date(data.timestamp.substring(0, 19))
                          )}{" "}
                          ago
                        </Box>
                      </Tooltip>
                    </TableCell>
                    <TableCell>
                      <Box className="hash-tag text-truncate">
                        <Link
                          href="/tx/0xcbddfe8514f46e34a7f2ed5ecc5853ee69f0e3e7bde1022341cdf68534aaeb95"
                          className="myFnExpandBox_searchVal"
                        >
                          {data.txCount}
                        </Link>
                      </Box>
                    </TableCell>

                    <TableCell>
                      <Tooltip title="Copy Address" placement="top">
                        <Link href={`/address/${data.producer}`}>
                          {data.producer}
                        </Link>
                      </Tooltip>
                      <ContentCopyIcon
                        className="text-icon text-muted"
                        onClick={() =>
                          navigator.clipboard.writeText(data.producer)
                        }
                      />
                    </TableCell>

                    <TableCell>{data.fee.toFixed(5)} UPC</TableCell>

                    <TableCell>0.00 UPC</TableCell>
                    <TableCell>
                      0.00 <span className="text-muted">(0.00%)</span>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box className="card-body">
            <Box className="d-flex flex-wrap align-items-center justify-content-between gap-3">
              <Box
                id="ContentPlaceHolder1_pageRecords"
                className="d-flex align-items-center gap-2 text-nowrap text-muted"
              >
                Show:
                <FormControl sx={{ m: 1, minWidth: 70 }}>
                  <Select
                    value={limit.toString()}
                    onChange={handleChange}
                    displayEmpty
                    size="small"
                    sx={{
                      fontSize: "12px",
                    }}
                  >
                    <MenuItem
                      value={10}
                      sx={{
                        fontSize: "12px;",
                      }}
                    >
                      10
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={25}
                    >
                      25
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={50}
                    >
                      50
                    </MenuItem>
                    <MenuItem
                      sx={{
                        fontSize: "12px;",
                      }}
                      value={100}
                    >
                      100
                    </MenuItem>
                  </Select>
                </FormControl>
                Records
              </Box>
              <Box className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                <Pagination
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  total={total}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default AllBlock;
